import type { ReactNode } from 'react';

export const symbol_shield_with_heart: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M340-517q0 48 49 94.5t80.84 75.27Q475-343 480-343t10.29-4.34Q522-376 571-422.58q49-46.57 49-94.48 0-31.94-22.75-54.44Q574.5-594 543-594q-19 0-35.5 7.5T480-566q-10.56-13.13-27.27-20.56-16.71-7.44-36.06-7.44-31.67 0-54.17 22.75T340-517ZM470.12-85q-4.56-1-9.12-3-139-47-220-168.5t-81-266.61V-719q0-19.26 10.88-34.66Q181.75-769.07 199-776l260-97q11-4 21-4t21 4l260 97q17.25 6.93 28.13 22.34Q800-738.26 800-719v195.89Q800-378 719-256.5T499-88q-4.56 2-9.12 3T480-84q-5.32 0-9.88-1Zm9.88-58q115-38 187.5-143.5T740-523v-196l-260-98-260 98v196q0 131 72.5 236.5T480-143Zm0-337Z"
		/>
	</svg>
);
